//extracted by mini-css-extract-plugin
export default {"closeButton":"styles_closeButton__7cWtC","mobilePanelHeader":"styles_mobilePanelHeader__xrWUI","mobileNotificationsContainer":"styles_mobileNotificationsContainer__zPk9x"};;